import api from './api';

export const getInvoicesData = (page, params) => {
  return api.get('admin/Invoices', { params: { page: page, limit: 10, order: 'createdAt', direction: 'DESC', ...params } });
};

export const getInvoicesDataBySearch = (searchItem, search) => {
  return api.get(`admin/Invoices?searchItem=${searchItem}&search=${search}`);
};
